<template>
  <form class="flex items-center border-b px-6" @submit.prevent>
    <Spinner v-if="loading" class="mr-4 h-6 w-6" />
    <SearchIcon v-else class="text-muted-foreground mr-4 h-4 w-4" />
    <input
      ref="input"
      v-model="query"
      class="bg-card h-14 flex-1 outline-none"
      type="text"
      placeholder="Search..."
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      @input="emit('update:query', query)"
      @keydown.up.prevent="emit('highlight:up')"
      @keydown.down.prevent="emit('highlight:down')"
    />
    <Button variant="ghost" size="icon" @click="emit('close')">
      <XIcon class="h-4 w-4" />
    </Button>
  </form>
</template>

<script setup lang="ts">
import { SearchIcon, XIcon } from '@lucide/vue';
import { nextTick, onMounted, type Ref, ref } from 'vue';

import { Button } from '@/shared/ui/button';
import { Spinner } from '@/shared/ui/spinner';

const input = ref() as Ref<HTMLInputElement | undefined>;
const query = ref('');

const emit = defineEmits(['close', 'update:query', 'highlight:up', 'highlight:down']);

defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});

const focus = () => input.value?.focus();

defineExpose({ focus });

onMounted(() => {
  nextTick(() => {
    if (input.value) {
      input.value.focus();
    }
  });
});
</script>
